import { User } from '../models'
import { Module, ActionContext } from 'vuex'
import { RootState, UsersState,CompanyState } from './state_models'
import {sortBy} from 'lodash'
import { UsersService } from '../services';
import {transformUserApiData} from '../util/helper'

let userListner;

export const users: Module<UsersState, RootState> = {
  namespaced: true,
  state: { users: [], locationId: '' },
  getters: {
    getById: (state: UsersState) => {
      return (userId: string) => state.users.find(x => x.id === userId)
    },
    getAll: (state: UsersState) => {
      return [...state.users.map(a=> new User(a))];
    }
  },
  mutations: {
    set: (state: UsersState, payload: { users: any[], locationId: string }) => {
      state.users = payload.users
      state.locationId = payload.locationId
    },
    clearAll: (state: UsersState) => {
      if (userListner) {
        userListner();
      }

      state.users = []
      state.locationId = undefined
    }
  },
  actions: {
    async syncAll(
      context: ActionContext<UsersState, RootState>,
      options: string | {locationId:string,force:boolean},
    ) {
      let force = false
      let locationId = options
      if(typeof options === 'object')
      {
        locationId = options.locationId
        force = options.force
      }

      if (!locationId) {
        context.commit('clearAll')
        return
      }


      if (context.state.locationId === locationId && !force) {
        return context.state.users;
      }

      return new Promise(async (resolve, reject) => {
        try
        {
          const resp = await UsersService.getByLocationId(locationId)
          const users = resp.users.map(u=>{
          return transformUserApiData(u)
        })
        
        context.commit('set', {
          locationId: locationId,
          users:
          sortBy(users
            ,
            [user => user.first_name ? user.first_name.toLowerCase() : '']
          )
        })

        resolve(context.state.users)
      } catch(err) {
          console.log(err)
          resolve([])
        }
      })
    },
    logout: {
      root: true,
      handler: async (context: ActionContext<UsersState, RootState>) => {
        context.commit('clearAll')
      }
    }
  }
}
